import React from "react";
import { createContext } from "react";
import { AssetType, useAssetProvide } from "./useAssetProvide";

export const assetContext = createContext<AssetType>({} as AssetType);

const AssetProvider: React.FC = ({ children }) => {
    const asset = useAssetProvide();
    return <assetContext.Provider value={asset}>{children}</assetContext.Provider>;
};

export default AssetProvider;
